import React from 'react';
import { Link } from 'react-router-dom';
import { Star, Car, Award, Zap } from 'lucide-react';
import { Badge } from '@/components/ui/badge';

export const ListingCard = ({ listing, onClick }) => {
  const mainPhoto = listing.photos?.[0] || 'https://images.unsplash.com/photo-1571799923032-df849d54bcb9?w=400';
  
  return (
    <div
      className="card-listing cursor-pointer"
      onClick={onClick}
      data-testid={`listing-card-${listing.listing_id}`}
    >
      {/* Image */}
      <div className="relative aspect-[4/3] overflow-hidden">
        <img
          src={mainPhoto}
          alt={listing.title}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
        />
        
        {/* Price tag */}
        <div className="absolute bottom-3 left-3 price-tag">
          <span className="text-lg">${listing.price_hourly}</span>
          <span className="text-slate-500 text-sm">/hr</span>
        </div>

        {/* Badges */}
        <div className="absolute top-3 left-3 flex flex-col gap-1.5">
          {/* Priority Listing badge (first 3,000 driveways) */}
          {listing.is_priority_listing && (
            <div className="flex items-center gap-1.5 bg-gradient-to-r from-purple-600 to-indigo-600 text-white text-xs font-semibold px-2.5 py-1 rounded-full shadow-lg">
              <Zap className="w-3.5 h-3.5" />
              Priority
            </div>
          )}
          {/* Early Host badge (first 1,000 hosts) */}
          {listing.is_early_adopter && (
            <div className="badge-early-adopter">
              <Award className="w-3.5 h-3.5" />
              Early Host
            </div>
          )}
        </div>
      </div>

      {/* Content */}
      <div className="p-4">
        <div className="flex items-start justify-between gap-2 mb-2">
          <h3 className="font-semibold text-slate-900 line-clamp-1 group-hover:text-[#5ebc67] transition-colors">
            {listing.title}
          </h3>
          {listing.average_rating > 0 && (
            <div className="flex items-center gap-1 text-sm shrink-0">
              <Star className="w-4 h-4 star-filled" />
              <span className="font-medium">{listing.average_rating.toFixed(1)}</span>
            </div>
          )}
        </div>
        
        <p className="text-sm text-slate-500 mb-3 line-clamp-1">
          {listing.suburb}, {listing.postcode}
        </p>

        {/* Vehicle sizes */}
        <div className="flex items-center gap-2 flex-wrap">
          {listing.vehicle_sizes?.slice(0, 3).map((size) => (
            <Badge key={size} variant="secondary" className="text-xs capitalize">
              <Car className="w-3 h-3 mr-1" />
              {size}
            </Badge>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ListingCard;
